<template>
  <div class="property-address columns is-vcentered is-centered">
    <img class="property-address__icon" :src="icon.svg" :alt="icon.type" />
    <p class="property-address__address">
      {{ address }}
    </p>
  </div>
</template>

<script>
import { apartmentFloor, apartmentCommercial, houseSingleFamily } from 'homeday-assets/L';

export default {
  name: 'PropertyAddress',
  data() {
    return {
      propertyIcon: {
        house: houseSingleFamily,
        apartment: apartmentFloor,
        commercial: apartmentCommercial,
      },
    };
  },
  computed: {
    icon() {
      return {
        svg:
          this.propertyIcon[this.$store.state.wizard.currentDeal.propertyType] ||
          this.propertyIcon.house,
        type: this.$store.state.wizard.currentDeal.propertyType,
      };
    },
    address() {
      return this.$store.state.wizard.currentDeal.address.formatted_address;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.property-address {
  &.columns {
    margin-bottom: $sp-xl + $sp-l;
  }

  &__icon {
    width: $sp-xl;
    height: auto;
  }

  &__address {
    @include fontGroup(300, 900);
    margin-left: $sp-m;
  }
}
</style>
